/** Templates
 *
 *  Container where all templates (ZZ.Template) are registered
 *
 */
(function() {
    ZZ.Templates = {
        // append new data to specific template
        appendTo: function(id, urlAddition) {
            if (typeof this[id] === "undefined") {
                return false;
            } else {
                this[id].appendData(urlAddition);
                return this[id];
            }
        }
    };
})();

/** Template
 *
 * Initiate template engine
 * Makes use of tempo.js (http://twigkit.github.com/tempo/)
 *
 * @param container: jQuery instance of HTML container element
 * Attributes on container:
 * - data-json-url (mandatory): URL of ajax-call
 * - data-template-url: URL of template file in case of external file
 *
 * @param json (optional): preloaded json for input data (so no ajax call needed)
 */
if (typeof jQuery != "undefined") {
    (function($) {
        ZZ.Template = function(container) {
            var base = this;

            // if template already exist, use that instance
            if (container.attr("id") && ZZ.Templates[container.attr("id")]) {
                base.container = ZZ.Templates[container.attr("id")].container;
                base.templateRenderer =
                    ZZ.Templates[container.attr("id")].templateRenderer;
            } else {
                base.container = container;
                base.templateRenderer = {};
            }
            base.loadTemplate();
        };

        ZZ.Template.prototype = {
            loadTemplate: function(json) {
                var base = this;
                if (typeof json !== "undefined") {
                    base.json = json;
                }
                // check if template is an external resource
                if (
                    typeof base.container.attr("data-template-url") !==
                    "undefined"
                ) {
                    var templateUrl = base.container.attr("data-template-url");
                    base.container.load(templateUrl, function() {
                        base.templateRenderer = Tempo.prepare(
                            base.container[0]
                        );
                        $(window).trigger("template_loaded");
                        base.registerTemplate();
                    });
                } else {
                    base.templateRenderer = Tempo.prepare(base.container[0]);
                    base.registerTemplate();
                }
            },

            appendData: function(json, urlAddition) {
                var base = this;

                // if json data is preloaded
                if (typeof json !== "undefined" && $.trim(json) !== "") {
                    base.templateRenderer.render(json);
                }
                // else get json data via ajax-call
                else {
                    // add timestamp to prevent caching
                    var dateTime = new Date().valueOf();
                    var jsonUrl =
                        base.container.attr("data-json-url") +
                        "?time=" +
                        dateTime;
                    if (typeof urlAddition !== "undefined") {
                        jsonUrl += "&" + urlAddition;
                    }

                    $.ajax({
                        url: jsonUrl,
                        redirLogout: true /* redirect in case logged out (redirect-proxy.js) */,
                        success: function(data) {
                            var parsedData = $.parseJSON(data);
                            base.templateRenderer.render(parsedData);
                            base.registerTemplate();
                            // scan the templates for new interaction elements
                            ZZ.init(base.container.get(0));
                            $(window).trigger("data_loading_done", [
                                base.container.attr("id")
                            ]);
                        },
                        statusCode: {
                            500: function() {
                                $(window).trigger("data_error_500", [
                                    base.container.attr("id")
                                ]);
                            }
                        }
                    });
                }
            },

            registerTemplate: function() {
                if (typeof this.container.attr("id") === "undefined") {
                    this.container.attr(
                        "id",
                        "template_" + new Date().valueOf()
                    );
                }
                ZZ.Templates[this.container.attr("id")] = this;
            }
        };
    })(jQuery);
}
